import { useEffect, useState } from 'react';
import ContainerWithGoBack from '../../../UI/ContainerWithGoBack';
import { findByUsuarioRespNuncaAcessou } from '../../../Usuario/api-usuario';
import { CircularProgress, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useLocation } from 'react-router';

const useStyles = makeStyles({
    title: {
        marginTop: '20px',
        marginBottom: '20px'
    },
    adicionarDisciplina: {
        paddingBottom: '10px',
    },
    formControl: {
        marginBottom: '10px'
    }
});


const UsuarioResponsavelFinanceiroNuncaAcessou = () => {
    const location = useLocation();
    const anoLetivo = location.state.anoLetivo;
    const [usuarios, setUsuarios] = useState([]);
    const [isLoading, setIsloading] = useState(true);
    const classes = useStyles();

    useEffect(() => {
        setIsloading(true);
        findByUsuarioRespNuncaAcessou(anoLetivo).then((data) => {
            if (data.error) {
                console.log(data);
            } else {
                setUsuarios(data);
            }
            setIsloading(false);
        })
    }, [anoLetivo]);


    return (
        <ContainerWithGoBack>
            <Typography className={classes.title} variant="h5">
                Relatório Responsáveis Financeiro nunca Acessaram o Sistema
            </Typography>


            {isLoading ?
                <div className={classes.loading}>
                    <CircularProgress color="primary" />
                    Carregando...
                </div> :
                <>
                    <Table size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Ano Letivo</TableCell>
                                <TableCell>Nome</TableCell>
                                <TableCell>E-mail</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {usuarios.map((u) => (
                                <TableRow key={u.id}>
                                    <TableCell>{anoLetivo}</TableCell>
                                    <TableCell>{u.nome}</TableCell>
                                    <TableCell>{u.email}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <Typography className={classes.title} variant="h5">
                        Total: {usuarios.length} responsáveis
                    </Typography>

                </>
            }


        </ContainerWithGoBack>
    );
}

export default UsuarioResponsavelFinanceiroNuncaAcessou;